<template>
  <rmr-segmented-control
    class="gw-support"
    :value="mediaType"
    :items="items"
    :variant="variant"
    @input="setMediaType"
  />
</template>

<script>
import { computed } from "@vue/composition-api";
import { mdiPlayCircleOutline, mdiTextBoxOutline } from "@mdi/js";

import RmrSegmentedControl from "@/components/ui/actions/RmrSegmentedControl.vue";

import useProxy from "@/hooks/useProxy";

export const MEDIA_TYPE_WRITTEN = "written";
export const MEDIA_TYPE_VIDEO = "video";

export default {
  name: "MediaTypeSegmented",
  components: {
    RmrSegmentedControl,
  },
  props: {
    variant: {
      type: String,
      default: "plain",
    },
    // Le support ne peut pas changer sans perimetre : basculer force la
    // recherche (cf. setMediaType), et `site_id` est obligatoire cote API.
    //
    // C'est au PARENT de dire s'il en a un, parce que les deux pages qui
    // portent ce toggle ne rangent pas le site au meme endroit :
    // « Creer post par sources » lit `aiFactory/getSelectedSites`, la page
    // « Veille globale » lit `newsRadar/getSites`. Lire l'un des deux ici
    // griserait le toggle en permanence sur l'autre page.
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { store } = useProxy();

    // =>  COMPUTED
    const mediaType = computed(
      () => store.getters["newsRadar/getMediaType"] || MEDIA_TYPE_WRITTEN
    );

    const items = computed(() =>
      [
        {
          value: MEDIA_TYPE_WRITTEN,
          label: "Écrit",
          icon: mdiTextBoxOutline,
        },
        {
          value: MEDIA_TYPE_VIDEO,
          label: "Vidéo",
          icon: mdiPlayCircleOutline,
        },
      ].map((item) => ({
        ...item,
        disabled: props.disabled,
        title: props.disabled ? "Choisissez d'abord un site" : item.label,
      }))
    );

    // =>  METHODS
    // Changer de support change le périmètre ET la mécanique de la vue : les
    // résultats affichés ne sont plus les bons, et une sélection faite en
    // écrit n'a aucun sens en vidéo. On relance donc la recherche, ce qui
    // purge au passage sélection et angles préparés (cf. `onNewSearch`).
    const setMediaType = (value) => {
      if (value === mediaType.value || props.disabled) return;
      store.dispatch("newsRadar/updateMediaType", value);
      // Les origines retenues appartiennent à l'autre support : les garder
      // filtrerait sur des entrées absentes de la nouvelle vue, donc sur du
      // vide. Même raison pour la config Full Auto, qui ne désigne que des
      // configs écrites — le full auto exclut les vidéos.
      store.dispatch("newsRadar/updateOrigins", []);
      if (value === MEDIA_TYPE_VIDEO) {
        store.dispatch("newsRadar/updateAifAutoConfig", null);
      }
      store.dispatch("common/updateApplyFilters", true);
    };

    // =>  DATA
    return {
      items,
      mediaType,
      setMediaType,
    };
  },
};
</script>

<style lang="scss" scoped>
.gw-support {
  flex-shrink: 0;
}
</style>
